import compose, { ComposedMiddleware } from 'koa-compose';

type Middleware = compose.Middleware<any>
type Middlewares = Array<Middleware>

class PluginManage {

    clientMiddlewares: Middlewares = []

    constructor() {
        console.log("Plugin")
    }

    addClientMiddleware(middleware: Middleware) {
        this.clientMiddlewares.push(middleware)
    }

    callClientMiddleware(ctx: any, callClient: ComposedMiddleware<any>) {
        const fnMiddleware = compose([].concat(this.clientMiddlewares, [callClient]));
        return fnMiddleware(ctx);
    }
}


const pluginManage = new PluginManage()

export default pluginManage;

type AddPluginOptions = {
    clientMiddleware?: Middleware,
}

export const addPlugin = ({ clientMiddleware }: AddPluginOptions) => {
    clientMiddleware && pluginManage.addClientMiddleware(clientMiddleware)
}